import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Tag } from '@src/app/models/tag';
import { timeout } from 'rxjs/operators';
import { TagadminService } from './service/tagadmin.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-tagadmin',
  templateUrl: './tagadmin.component.html',
  styleUrls: ['./tagadmin.component.css']
})
export class TagadminComponent implements OnInit {
  showSpinner:boolean;
  customerTags:Tag[];

  projectTags:Tag[];
  newtagtitle:string;
  constructor(private tasrv: TagadminService) { }

  ngOnInit(): void {
    this.showSpinner = true;
    this.tasrv.getTags().pipe(untilDestroyed(this)).subscribe(tags => {
      this.customerTags = tags.filter(x => x.tagtype == 'customer');
      this.showSpinner = false;
    })
    this.tasrv.getTags().pipe(untilDestroyed(this)).subscribe(tags => {
      this.projectTags = tags.filter(x => x.tagtype == 'project');
      this.showSpinner = false;
    })

  }
  editTag(tag:Tag){
    //wait a bit then save new title
    this.showSpinner = true;
    setTimeout(()=>{
      //start spinner
      this.tasrv.saveTag(tag).pipe(untilDestroyed(this)).subscribe(x =>  {
        this.showSpinner = false;
      })
    },100)
  }
  addTag(type:string){
    this.showSpinner = true;
    let newtag = {
      title: this.newtagtitle,
      created: new Date().toDateString(),
      creator: SessionHelper.getUserSub(),
      tagId: new Date().toDateString(),
      tagtype: type,
      organizationId: SessionHelper.getChoosenOrg(),
      organizationname: ''
    };
    this.tasrv.addTag(newtag).pipe(untilDestroyed(this)).subscribe(x => {
      if(type === 'project') this.projectTags.push(newtag);
      if(type === 'customer')this.customerTags.push(newtag);

      this.newtagtitle = "";
      this.showSpinner = false;
    });
  }
  deleteTag(tag:Tag){
    this.showSpinner = true;
    this.tasrv.deleteTag(tag).pipe(untilDestroyed(this)).subscribe(x => {
      this.customerTags.splice(this.customerTags.indexOf(tag),1);
      this.showSpinner = false;
    });
  }
}
